import { render } from "./OAuth.vue?vue&type=template&id=f5908896&scoped=true"
import script from "./OAuth.vue?vue&type=script&lang=js"
export * from "./OAuth.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=f5908896&scoped=true&lang=css&external"
import "./OAuth.vue?vue&type=style&index=1&id=f5908896&scoped=true&lang=css"
import "./OAuth.vue?vue&type=style&index=2&id=f5908896&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5908896"]])

export default __exports__